module.exports = __webpack_public_path__ + "1fac78f0aa1600ec7a9f9d67b9bf1ada.jpg";